import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * Compact quantity dropdown inside the cart. Dispatches quantity updates to cart-items-component.
 *
 * @extends {Component}
 */
class CartLineQuantityPicker extends Component {
  /** @type {AbortController} */
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const select = this.querySelector('[data-cart-quantity-select]');
    select?.addEventListener('change', this.#onChange, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const quantity = Number(select.value);
    const previous = Number(select.dataset.defaultQuantity);
    const line = Number(this.dataset.line);

    if (!line || Number.isNaN(quantity) || quantity === previous) return;

    select.disabled = true;
    this.dispatchEvent(new QuantitySelectorUpdateEvent(quantity, line));
  };
}

if (!customElements.get('cart-line-quantity-picker')) {
  customElements.define('cart-line-quantity-picker', CartLineQuantityPicker);
}